import type { RealsProperty } from "../interfaces/realsProperties";

export async function fetchMatterPorts(): Promise<RealsProperty[]> {
  const url = "https://app.zown.ca/matterport.json";

  try {
    const response = await fetch(url, {
      headers: {
        method: "GET",
      },
    });
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    const data = await response.json();

    if (!data) {
      throw new Error("No data returned from the API");
    }
    return data as RealsProperty[];
  } catch (error) {
    console.error("There was a problem fetching the posts:", error);
    throw error;
  }
}
